var exports = {
  "o": "Token__Br8j8M",
  "R": "colorIndicator__t5cXA8",
};

module.exports = exports;
